import { defineStore } from 'pinia'

export const mmStore = defineStore('Store', {
    state: () => ({
        /** @type {{ text: string, id: number, isFinished: boolean }[]} */
        todos: [],
        /** @type {'all' | 'finished' | 'unfinished'} */
        filter: 'all',
        // type will be automatically inferred to number
        nextId: 0,
    }),
    getters: {
        finishedTodos(state) {
            // autocompletion!
            return state.todos.filter((todo) => todo.isFinished)
        },
        unfinishedTodos(state) {
            return state.todos.filter((todo) => !todo.isFinished)
        },
        /**
         * @returns {{ text: string, id: number, isFinished: boolean }[]}
         */
        filteredTodos(state) {
            state.todos;
            if (this.filter === 'finished') {
                // call other getters with autocompletion
                return this.finishedTodos
            } else if (this.filter === 'unfinished') {
                return this.unfinishedTodos
            }
            return this.todos
        },
    },
    actions: {
        // any amount of arguments, return a promise or not
        addTodo(text, finished) {
            // you can directly mutate the state
            // console.log(this.finishedTodos());
            this.todos.push({ text, id: this.nextId++, isFinished: finished || false })
            // console.log(this.finishedTodos());
        },
        clearTodo() {
            // you can directly mutate the state
            this.todos = [];
        },
        changeFilter(filterby) {
            // you can directly mutate the state
            this.filter = filterby || 'all';
        },
    },
});

// const unsubscribe = mmStore.$onAction(
//     ({
//       name, // name of the action
//       store, // store instance, same as `someStore`
//       args, // array of parameters passed to the action
//       after, // hook after the action returns or resolves
//       onError, // hook if the action throws or rejects
//     }) => {
//       // a shared variable for this specific action call
//       const startTime = Date.now()
//       // this will trigger before an action on `store` is executed
//       console.log(`Start "${name}" with params [${args.join(', ')}].`)

//       // this will trigger if the action succeeds and after it has fully run.
//       // it waits for any returned promised
//       after((result) => {
//         console.log(
//           `Finished "${name}" after ${
//             Date.now() - startTime
//           }ms.\nResult: ${result}.`
//         )
//       })

//       // this will trigger if the action throws or returns a promise that rejects
//       onError((error) => {
//         console.warn(
//           `Failed "${name}" after ${Date.now() - startTime}ms.\nError: ${error}.`
//         )
//       })
//     }
//   )

//   // manually remove the listener
//   unsubscribe()
// //   mmStore.$onAction(callback, true)